export class CampaignExperience {
  songStreams: number = null;
  songLink: string = null;
}
